import { Head } from 'vite-react-ssg'
import Header from '../components/Header'
import Footer from '../components/Footer'

export default function Disclaimer() {
  return (
    <div className="os-root">
      <Head>
        <title>Disclaimer · Original Savage</title>
        <meta name="description" content="Original Savage publishes educational preparedness content only. It is not professional medical, legal or financial advice, nor a substitute for training." />
        <link rel="canonical" href="https://originalsavage.com/disclaimer" />
      </Head>
      <Header />
      <main id="main">
        <section className="wrap sec art-detail">
          <h1>Disclaimer</h1>
          <div className="article-body">
            <p>
              Original Savage publishes educational content about prepping, self-sufficiency, and home readiness. Nothing on this site is
              professional medical, legal, or financial advice, and none of it has been evaluated by the FDA or any other regulatory body.
            </p>
            <h2>Not medical advice</h2>
            <p>
              Articles that touch first aid, water treatment, food preservation, or similar topics reflect general, publicly available
              guidance from sources like the CDC, EPA, Red Cross, and similar organizations, cited inline wherever we reference them.
              None of our authors are medical professionals. Always consult a qualified clinician for actual medical concerns, and call
              emergency services when a situation calls for it, regardless of distance or convenience.
            </p>
            <h2>Not legal or financial advice</h2>
            <p>
              Anything touching law (firearms, self-defense, insurance, financial planning) varies by state and country and changes over
              time. Verify against current local law and a licensed professional before acting on it.
            </p>
            <h2>Use your judgment</h2>
            <p>
              We flag genuinely safety-critical statements inline with a <strong>⚠️ SAFETY</strong> callout and a note to verify against
              current local law or manufacturer guidance. That flag is a prompt to double-check, not a substitute for it. You're
              responsible for how you apply anything you read here.
            </p>
            <h2>Contact</h2>
            <p>
              Questions about this disclaimer or anything on the site: <a href="mailto:contact@originalsavage.com">contact@originalsavage.com</a>.
            </p>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  )
}
